import apiError from '@/api/apierror'
import RESTFUL_axios from '@/api/restful_axois'

const trim = (str) => {
  if (!str) return ''
  var reg = /^(\s|\xA0)+|(\s|\xA0)+$/g
  return str.replace(reg, '')
}

const RESTFUL_fn = (apiType, reqData) => {
  var apiName = 'publesson'
  var reqName = apiName + '_' + apiType
  var apiConfigs = {
    _getCourseInfo: {
      url: '/course/app/course/invite-course/by-cno',
      data: () => {
        var data = {
          cno: reqData.cno,
        }
        return data
      },
      dataType: 'json',
      transformResponse: (res) => {
        switch (res.error_info.errno) {
          case 1:
          case 130:
          case 153:
          case 829:
            var resData = res.data
            var courseInfo = {}
            if (resData) {
              courseInfo = {
                ...resData,
                courseId: resData.courseId,
                schoolName: resData.schoolName,
                courseLogo: resData.courseImg && resData.courseImg.sPic ? resData.courseImg.sPic : '',
                courseName: resData.courseName,
                teacherList: [],
                teacherNum: resData.teacherNum * 1,
                schoolIntroduction: resData.schoolIntroduce,
                signUpStatus: '',
              }
              let signUpStatus = ''
              switch (res.error_info.errno) {
                case 1:
                  signUpStatus = ''
                  break
                case 130:
                  signUpStatus = 'courseStuFull'
                  break
                case 153:
                  signUpStatus = 'courseDisband'
                  break
                case 829:
                  signUpStatus = 'courseClose'
                  break
              }
              courseInfo.signUpStatus = signUpStatus

              resData.teachers.forEach((v) => {
                courseInfo.teacherList.push({
                  teacherName: v.nickName || v.name || v.mobile || v.email,
                  teacherLogo: v.teacherLogo,
                  identify: v.identify * 1, //3-教师 5-班主任
                })
              })
            }
            return {
              courseInfo: courseInfo,
            }
          case 104:
          case 147:
          case 149:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
    // 检查手机号,邮箱是否注册
    _userRegister: {
      // url: '/saasajax/user.ajax.php?action=userRegister',
      url: '/usercenter/v2/web/user/userRegister',
      data: function () {
        var phoneNumber = trim(reqData.mobile)
        const mobile = phoneNumber ? (reqData.selectArea == '0086' ? phoneNumber : reqData.selectArea + '-' + phoneNumber) : ''
        var serverPostData = {
          mobile,
          email: reqData.email,
          verificationCode: trim(reqData.verificationCode),
          nickName: reqData.nickName,
          password: trim(reqData.password),
          isLogin: reqData.isLogin,
          source: 1, // 内容来源:1-班级 2-公开课
        }
        return serverPostData
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 111:
          case 1040:
          case 1041:
          case 1042:
          case 1043:
          case 1008:
          case 100:
          case 101:
          case 102:
          case 108:
          case 109:
          case 110:
          case 113:
          case 133:
          case 134:
          case 135:
          case 136:
          case 166:
          case 20704:
          case 20718:
          case 20727:
          case 20728:
          case 20729:
          case 20730:
          case 20731:
          case 20732:
          case 20733:
          case 20734:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
    /**
     * 检查是否处于青少年模式
     * https://apifox.eeo-inc.com/apidoc/shared-653e3001-d033-4b87-9d22-fc9c76251c35/api-3496940
     */
    _checkYoung: {
      url: '/usercenter/v2/web/young/checkYoungByMobileOrEmail',
      data: function () {
        var phoneNumber = trim(reqData.mobile)
        const mobile = phoneNumber ? (reqData.selectArea == '0086' ? phoneNumber : reqData.selectArea + '-' + phoneNumber) : ''
        var serverPostData = {
          mobile,
          email: reqData.email,
        }
        return serverPostData
      },
      transformResponse: function (res) {
        const errno = res.error_info.errno
        console.log('%c ====checkYoungByMobile====', 'color: #fff;background: purple;font-size: 24px;', res)
        if (errno == 1) {
          return res
        } else {
          apiError({
            name: reqName,
            code: res.error_info.errno,
            intro: res.error_info.error,
            url: apiConfigs['_' + apiType].url,
            req: reqData,
            res: res,
          })
        }
      },
    },
    // 自助添加为课程学生
    _addCourseStu: {
      url: '/saasajax/user.ajax.php?action=userSelfAddCourseStudent',
      data: function () {
        var phoneNumber = trim(reqData.mobile)
        const mobile = phoneNumber ? (reqData.selectArea == '0086' ? phoneNumber : reqData.selectArea + '-' + phoneNumber) : ''
        var serverPostData = {
          courseId: reqData.courseId,
          mobile,
          identifyCode: trim(reqData.identifyCode),
          email: reqData.email,
          name: reqData.name,
        }
        reqData.nickName && (serverPostData.name = reqData.nickName)
        return serverPostData
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 111:
          case 113:
          case 128:
          case 130:
          case 144:
          case 149:
          case 153:
          case 163:
          case 212:
          case 304:
          case 333:
          case 829:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
    _check: {
      // url: '/saasajax/user.ajax.php?action=checkRegister',
      url: '/usercenter/v2/web/user/checkVerificationCode',
      data: function () {
        var serverPostData = {
          mobile: reqData.telephone.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, ''),
          verificationCode: reqData.verificationCode,
        }
        return serverPostData
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 113:
            return false
          case 104:
          case 134:
            return res.error_info.errno
          case 135:
            return true
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
    _sendCode: {
      // url: '/saasajax/user.ajax.php?action=sendCodeAndCheckRegister',
      url: '/usercenter/v2/web/user/sendCodeAndCheckRegister',
      // host: replaceOrigin(),
      data: function () {
        var phoneNumber = trim(reqData.mobile)
        const mobile = phoneNumber ? (reqData.selectArea == '0086' ? phoneNumber : reqData.selectArea + '-' + phoneNumber) : ''
        var serverPostData = {
          mobile,
          // ...reqData.captcha,
          sceneCode: 2, // sceneCode=2 发送短信场景参数 登录
          type: reqData.type,
          email: reqData.email,
          verifyToken: reqData.vToken,
          verifyType: reqData.vType,
          // ticket: reqData.ticket,
          // randStr: reqData.randStr
          //graphicCode:reqData.picCode.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '')
        }
        return serverPostData
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
            let resData = res.data
            if (resData) {
              return resData.isRegister * 1 ? true : false
            }
            break
          case 104:
          case 108:
          case 109:
          case 110:
          case 134:
          case 100:
          case 101:
          case 102:
          case 113:
          case 133:
          case 135:
          case 136:
          case 166:
          case 20704:
          case 20718:
          case 20727:
          case 20728:
          case 20729:
          case 20730:
          case 20731:
          case 20732:
          case 20733:
          case 20734:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
  }
  return RESTFUL_axios({
    reqName: reqName,
    reqConfig: apiConfigs['_' + apiType],
    reqData: reqData,
  })
}
export default RESTFUL_fn
